import type { ReactNode } from 'react'
import { UnreadBadge } from '@/components/UnreadBadge'
import {
  SplitViewSidebarListItem,
  SplitViewSidebarListItemTitle,
  SplitViewSidebarListItemSubtitle,
  SplitViewSidebarListItemPretitle,
} from '@/components/SplitView/SplitViewSidebarListItem'
import styles from './JobItem.module.css'

export interface JobItemProps {
  to: string
  isActive: boolean
  visual: ReactNode
  lastActivity: string
  unreadCount: number
  workspaceName?: string
  jobName: string
  collaboratorNames: string
}

export function JobItem({
  to,
  isActive,
  visual,
  lastActivity,
  unreadCount,
  workspaceName,
  jobName,
  collaboratorNames,
}: JobItemProps) {
  return (
    <SplitViewSidebarListItem
      to={to}
      active={isActive}
      visual={visual}
      extras={
        <div className={styles.stats}>
          <span className={styles.lastActivity}>{lastActivity}</span>
          {unreadCount > 0 && (
            <span className={styles.unread}>
              <UnreadBadge count={unreadCount} />
            </span>
          )}
        </div>
      }
    >
      {workspaceName !== undefined && (
        <SplitViewSidebarListItemPretitle title={workspaceName}>
          {workspaceName}
        </SplitViewSidebarListItemPretitle>
      )}
      <SplitViewSidebarListItemTitle title={jobName}>
        {jobName}
      </SplitViewSidebarListItemTitle>
      <SplitViewSidebarListItemSubtitle title={collaboratorNames}>
        {collaboratorNames}
      </SplitViewSidebarListItemSubtitle>
    </SplitViewSidebarListItem>
  )
}
